import styled, { createGlobalStyle } from 'styled-components';

export const TradeInModalLayerStyles = createGlobalStyle`
    .sales-checkin-modal-wrapper.trade-in-modal-layer [height='auto'] {
        background-color: #ffffff;
        border: 1px solid #d0cccc;
        box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
        border-radius: 0.5rem;
        overflow: hidden;
    }

    .sales-checkin-modal-wrapper.trade-in-modal-layer [height='auto'] > div,
    .sales-checkin-modal-wrapper.trade-in-modal-layer .trade-in-modal-content {
        background-color: #ffffff;
        overflow: hidden;
    }
`;

export const TradeInModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: visible;
    font-size: 1rem;
    color: black;

    &.trade-in-modal-content {
        background-color: #ffffff;

        .modal-dialog {
            margin: 0 auto;
            width: 100%;
            max-width: 560px;
        }

        .modal-content {
            width: 100%;
        }
    }
`;

export const TradeInListItem = styled.div<{ isSelected?: boolean }>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0;
    border-radius: 4px;
    background-color: transparent;
    border: 0;
    transition: all 0.2s ease-in-out;

    &:hover {
        background-color: transparent;
    }
`;

export const TradeInCheckboxWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    min-width: 0;
`;

export const TradeInVehicleInfo = styled.span<{ isSelected?: boolean }>`
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: ${({ isSelected }) => (isSelected ? '#000000' : '#00000099')};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const TradeInStatusBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 2px 8px;
    background-color: #e3e3e3;
    color: #000000;
    border-radius: 10px;
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
    margin-left: 10px;
    text-transform: none;
`;

export const TradeInActions = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;
    margin-top: 12px;
    padding-top: 10px;
    border-top: 0;

    .cancel-button {
        background-color: transparent;
        border: 0;
        color: ${({ theme }) => theme.uiBricks?.primaryAccentColor || '#01336b'};
        padding: 0;
        min-height: unset;
        font-size: 18px;
        line-height: 20px;

        &:hover,
        &:focus,
        &:active {
            background-color: transparent;
            border: 0;
            color: ${({ theme }) => theme.uiBricks?.primaryAccentColor || '#01336b'};
        }
    }

    .continue-button {
        background-color: ${({ theme }) => theme.uiBricks?.primaryAccentColor || '#01336b'};
        border-color: ${({ theme }) => theme.uiBricks?.primaryAccentColor || '#01336b'};
        color: #ffffff;
        width: 286px;
        max-width: 100%;
        min-height: 44px;
        padding: 10px 20px;
        border-radius: 3px;
        font-size: 18px;
        line-height: 26px;
        font-weight: 600;

        &:disabled {
            background-color: #a7adb3;
            border-color: #a7adb3;
            color: #f2f4f7;
            cursor: not-allowed;
        }
    }
`;

export const CustomCheckbox = styled.input.attrs({ type: 'checkbox' })`
    width: 24px;
    height: 24px;
    cursor: pointer;
    accent-color: #0a468d;
    flex-shrink: 0;
`;
